'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { af, $d, rf } from './sell-market-animation';
import { w, referenceBrands } from './workflow-facts';
import { ShowcaseIcon } from './scene-primitives';
export function Render_sf({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'pd-sheet grid size-full place-items-center'}>
      <svg
        viewBox={'30 20 280 240'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={'2.5'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        aria-hidden={!0}
        className={'text-ink h-[80%] w-auto'}
      >
        {translateShowcaseNode(
          showcaseCopy,
          [
            'M46 120H198V240H46Z',
            'M85 147V120C85 13 159 13 159 120V147',
            'M95 147V120C95 27 149 27 149 120V147',
            'M236 120H292V240H236Z',
            'M85 147H95M149 147H159',
          ].map((t, n) => (
            <path
              key={t}
              d={t}
              pathLength={1}
              data-on={af(e, 120 + n * 110)}
              className={'pd-line'}
            />
          ))
        )}
        <path
          d={'M46 258H198M236 258H292'}
          pathLength={1}
          data-on={af(e, 800)}
          className={'pd-line text-ink-3'}
          strokeWidth={'1.5'}
        />
      </svg>
    </div>
  );
}
export function Render_cf({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = w.cost
      .slice(2, -1)
      .map((e) => [e.label.replace(', 300 units', ''), e.base]),
    n = t.reduce(
      (t, [, n], r) => t + Math.round($d(e, 150 + r * 160, 400) * n),
      0
    );
  return (
    <div
      className={
        'bg-raised flex size-full flex-col p-2.5 font-mono text-[10px] leading-none'
      }
    >
      <div
        className={
          'text-ink-3 mb-1 flex h-5 items-center gap-1.5 rounded-[4px] bg-[var(--tint)] px-1.5'
        }
      >
        <span className={'text-ink-4'}>
          {translateShowcaseNode(showcaseCopy, 'fx')}
        </span>
        <span className={'text-ink truncate'}>
          {translateShowcaseNode(showcaseCopy, '=SUM(C4:C7)')}
        </span>
      </div>
      <div className={'grid grid-cols-[1fr_auto] text-[10px]'}>
        {translateShowcaseNode(
          showcaseCopy,
          t.map(([t, n], r) => (
            <span key={t} className={'contents'}>
              <span
                className={
                  'text-ink-3 border-b border-[var(--line)] py-[2px] sm:py-[4px]'
                }
              >
                {translateShowcaseNode(showcaseCopy, t)}
              </span>
              <span
                className={
                  'num text-ink border-b border-[var(--line)] py-[2px] text-right sm:py-[4px]'
                }
              >
                {translateShowcaseNode(
                  showcaseCopy,
                  e >= 150 + r * 160 ? `€${n.toLocaleString('en-US')}` : ''
                )}
              </span>
            </span>
          ))
        )}
        <span className={'text-ink py-[2px] font-semibold sm:py-[4px]'}>
          {translateShowcaseNode(showcaseCopy, 'Total')}
        </span>
        <span
          className={
            'num text-ink [padding-inline:4px] py-[2px] text-right font-semibold shadow-[inset_0_0_0_1.5px_var(--foreground)] sm:py-[4px]'
          }
        >
          {translateShowcaseNode(showcaseCopy, '\u20AC')}
          {translateShowcaseNode(showcaseCopy, n.toLocaleString('en-US'))}
        </span>
      </div>
    </div>
  );
}
export function Render_lf() {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'grid size-full place-items-center bg-[var(--tint)] p-2.5'}>
      <div
        className={
          'grid aspect-video w-full grid-cols-[1fr_0.9fr] overflow-hidden rounded-[5px] bg-[#EFE7DC] shadow-[var(--shadow-minimal)]'
        }
      >
        <div className={'flex flex-col justify-between p-2 text-[#4A3426]'}>
          <span
            className={'font-[Georgia,serif] text-[6.5px] tracking-[0.22em]'}
          >
            {translateShowcaseNode(
              showcaseCopy,
              referenceBrands.orvieto.name.toUpperCase()
            )}
          </span>
          <span className={'font-[Georgia,serif] text-[11px] leading-tight'}>
            {translateShowcaseNode(showcaseCopy, 'Box tote')}
          </span>
          <span className={'text-[6px] tracking-[0.08em] opacity-70'}>
            {translateShowcaseNode(showcaseCopy, 'Line review \xB7 1 / 12')}
          </span>
        </div>
        <img
          src={rf.src}
          alt={translateShowcaseNode(showcaseCopy, '')}
          loading={'lazy'}
          className={'size-full object-cover'}
        />
      </div>
    </div>
  );
}
export function Render_uf({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'bg-raised flex size-full flex-col gap-1.5 p-3'}>
      <span className={'text-ink text-[10.5px] leading-tight font-semibold'}>
        {translateShowcaseNode(showcaseCopy, 'Supplier brief')}
      </span>
      <span className={'text-ink-4 mb-1 text-[8.5px] leading-none'}>
        {translateShowcaseNode(showcaseCopy, 'Casa Orvieto \xB7 tote')}
      </span>
      {translateShowcaseNode(
        showcaseCopy,
        [88, 72, 94, 66, 82, 58, 76].map((t, n) => (
          <span
            key={n}
            className={
              'block h-[3px] origin-left rounded-full bg-[var(--tint-2)] transition-transform duration-500 ease-[var(--ease)]'
            }
            style={{
              width: `${t}%`,
              transform: `scaleX(${+(e >= 100 + n * 70)})`,
            }}
          />
        ))
      )}
    </div>
  );
}
export function Render_df({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div
      className={'relative grid size-full place-items-center bg-[var(--tint)]'}
    >
      <svg
        viewBox={'0 0 120 90'}
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth={'1.2'}
        strokeLinecap={'round'}
        strokeLinejoin={'round'}
        aria-hidden={!0}
        className={'text-ink h-[86%] w-auto'}
      >
        {translateShowcaseNode(
          showcaseCopy,
          [
            'M30 42 70 32 96 40 56 51Z',
            'M30 42 31 71 57 80 56 51',
            'M96 40 95 68 57 80',
            'M44 46C44 12 70 6 72 39',
          ].map((t, n) => (
            <path
              key={t}
              d={t}
              pathLength={1}
              data-on={af(e, 100 + n * 140)}
              className={'pd-line'}
            />
          ))
        )}
        <ellipse
          cx={'61'}
          cy={'74'}
          rx={'44'}
          ry={'11'}
          className={'pd-fade pd-dash text-ink-4'}
          data-on={af(e, 700)}
        />
        <path
          d={'M100 79l5 2-3 4'}
          className={'pd-fade text-ink-3'}
          data-on={af(e, 800)}
        />
      </svg>
      <span
        className={
          'text-ink-2 absolute top-2 left-2 flex h-5 items-center gap-1 rounded-full bg-[var(--panel)] px-1.5 text-[10px] shadow-[var(--shadow-minimal)]'
        }
      >
        <ShowcaseIcon name={'cube'} className={'size-3'} />
        {translateShowcaseNode(showcaseCopy, '3D')}
      </span>
    </div>
  );
}
export const ff = [
  3, 6, 9, 5, 11, 7, 4, 8, 12, 6, 9, 4, 7, 10, 5, 3, 6, 9, 5, 4,
];
export function Render_pf({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'relative size-full'} data-on={af(e, 200)}>
      <img
        src={rf.src}
        alt={translateShowcaseNode(showcaseCopy, '')}
        loading={'lazy'}
        className={'size-full object-cover object-[50%_40%]'}
      />
      <div
        className={
          'absolute inset-x-1.5 bottom-1.5 flex h-7 items-center gap-1.5 rounded-[7px] bg-black/55 px-2 text-white backdrop-blur-md'
        }
      >
        <ShowcaseIcon name={'play'} className={'size-3 shrink-0'} />
        <span className={'pd-wave flex h-3.5 flex-1 items-center gap-[2px]'}>
          {translateShowcaseNode(
            showcaseCopy,
            ff.map((e, t) => (
              <span
                key={t}
                className={'block w-[2px] rounded-full bg-white/85'}
                style={{
                  height: `${e + 2}px`,
                  '--i': String(t),
                }}
              />
            ))
          )}
        </span>
        <ShowcaseIcon name={'speaker'} className={'size-3 shrink-0'} />
      </div>
    </div>
  );
}
export const productionIconPaths = {
  flag: ['M5 17V3.5', 'M5 4h9l-2 3.5 2 3.5H5'],
  alert: ['M10 3.5 17.5 16.5h-15z', 'M10 8.5v3.5', 'M10 14.2v.1'],
  info: ['M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14z', 'M10 9.2v4.6', 'M10 6.6v.1'],
  package: [
    'M10 3 16.5 6.3v7.4L10 17l-6.5-3.3V6.3z',
    'M3.5 6.3 10 9.6l6.5-3.3',
    'M10 9.6V17',
    'M6.8 4.7l6.5 3.3',
  ],
  download: ['M10 4v8.5', 'M6.5 9 10 12.5 13.5 9', 'M4.5 15.5h11'],
  expand: ['M12 4h4v4', 'M8 16H4v-4', 'M16 4l-4.5 4.5', 'M4 16l4.5-4.5'],
  send: ['M3.5 10 16.5 4l-4 12.5-2.8-5.2z', 'M9.7 11.3 16.5 4'],
  list: [
    'M7.5 6h9',
    'M7.5 10h9',
    'M7.5 14h9',
    'M4 6h.1',
    'M4 10h.1',
    'M4 14h.1',
  ],
  grid: ['M4 4h5v5H4z', 'M11 4h5v5h-5z', 'M4 11h5v5H4z', 'M11 11h5v5h-5z'],
  more: ['M5 10h.1', 'M10 10h.1', 'M15 10h.1'],
  circleCheck: [
    'M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14z',
    'm7 10.2 2.1 2.1 4-4.3',
  ],
  circleAlert: [
    'M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14z',
    'M10 6.8v3.8',
    'M10 13.2v.1',
  ],
  circleX: [
    'M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14z',
    'm7.6 7.6 4.8 4.8',
    'm12.4 7.6-4.8 4.8',
  ],
  overlap: [
    'M8 4a5 5 0 1 1 0 10 5 5 0 0 1 0-10z',
    'M12 6a5 5 0 1 1 0 10 5 5 0 0 1 0-10z',
  ],
  gap: ['M3.5 10h4', 'M12.5 10h4', 'M7.5 6.5v7', 'M12.5 6.5v7'],
  rotate: ['M15.5 9A5.5 5.5 0 1 0 14 13.6', 'M15.8 5v4h-4'],
};
export function ProductionIcon({
  name: e,
  className: t = 'size-4',
  on: n,
  strokeWidth: r = 1.5,
  style: i,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <svg
      viewBox={'0 0 20 20'}
      fill={'none'}
      stroke={'currentColor'}
      strokeWidth={r}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
      aria-hidden={!0}
      className={t}
      style={i}
    >
      {translateShowcaseNode(
        showcaseCopy,
        productionIconPaths[e].map((e) => (
          <path
            key={e}
            d={e}
            pathLength={n === void 0 ? void 0 : 1}
            className={n === void 0 ? void 0 : 'pd-line pd-line-fast'}
            data-on={n === void 0 ? void 0 : String(n)}
          />
        ))
      )}
    </svg>
  );
}
export const hf = {
  lisiere: {
    paper: '#F2EEE6',
    ink: '#1C1A17',
  },
  orvieto: {
    paper: '#EFE7DC',
    ink: '#4A3426',
  },
};
